import { AnimatedList } from '../motion';

/**
 * UnifiedCardGrid — responsive grid for cards/kacheln.
 * See UNIFIED_UI_ARCHITECTURE.md §5.4
 *
 * Default: 3 columns desktop, 2 tablet, 1 mobile. 16px gap.
 */
export default function UnifiedCardGrid({
  children,
  columns = { desktop: 3, tablet: 2, mobile: 1 },
  gap = 4,
  className = '',
}) {
  const cols = typeof columns === 'number'
    ? { desktop: columns, tablet: Math.min(columns, 2), mobile: 1 }
    : { desktop: 3, tablet: 2, mobile: 1, ...columns };

  const gridClass = `unified-card-grid-${cols.desktop}-${cols.tablet}-${cols.mobile}`;

  return (
    <div data-testid="unified-card-grid">
      <style>{`
        .${gridClass} { display: grid; grid-template-columns: repeat(${cols.mobile}, 1fr); align-items: stretch; gap: var(--aif-space-3); }
        @media (min-width: 768px) { .${gridClass} { grid-template-columns: repeat(${cols.tablet}, 1fr); gap: var(--aif-space-4); } }
        @media (min-width: 1280px) { .${gridClass} { grid-template-columns: repeat(${cols.desktop}, 1fr); gap: var(--aif-space-4); } }
        .${gridClass} > div { display: flex; }
        .${gridClass} > div > * { flex: 1; }
      `}</style>
      <AnimatedList className={`${gridClass} ${className}`}>
        {children}
      </AnimatedList>
    </div>
  );
}
